// same gross approach as http://stackoverflow.com/questions/190852/how-can-i-get-file-extensions-with-javascript/1203361#1203361
export default function getFileBasename(fname) {
  return fname
    .substr(fname.lastIndexOf('/') + 1)
    .split('?')[0]
    .split('#')[0];
}

// Eagerly-uploaded files are S3 URLs whose key ends in the (scrubbed) filename.
// Returns null for anything that is not a parseable URL.
export function fileNameFromUrl(url) {
  try {
    return decodeURIComponent(getFileBasename(new URL(url).pathname));
  } catch {
    return null;
  }
}
